import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { BasicXpacInfo, ControllerTypeFilter } from 'src/app/generated/CrossPoint.RemoteXpac.Server';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';
import { DevicesActionsTypes, getDevicesAction } from 'src/app/store/actions/devices.actions';
import { Actions, ofType } from '@ngrx/effects';
import { IDataAction } from 'src/app/utils/interfaces/common.interfaces';

@Injectable({
  providedIn: 'root'
})
export class DeviceStateResolver {
  constructor(
    private store: Store<IRemoteXPACPortalState>,
    private actions$: Actions,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<BasicXpacInfo> {
    const id: string = route.params.id;
    const obs = this.actions$.pipe(
      ofType(DevicesActionsTypes.GET_DEVICES_SUCCESS, DevicesActionsTypes.GET_DEVICES_FAILED),
      take(1),
      map((a: { type: DevicesActionsTypes } & IDataAction<{ devices: BasicXpacInfo[] }>) => {
        let device: BasicXpacInfo;
        if (a.type === DevicesActionsTypes.GET_DEVICES_SUCCESS) {
          device = a.data.devices.find(d => d.deviceId === id);
        }
        if (!device) {
          device = {
            ccap: false,
            deviceId: null,
            firmware: null,
            hasSubscription: false,
            installationDateUtc: null,
            isConnected: false,
            problemCount: 0,
            retailerCompany: null,
            shardId: null,
            storeAddress: null,
            storeLocation: null,
            storeCodes: null,
            storeName: null,
            lastConnectionChangeUtc: null,
            retailerCompanyId: null,
            networkInterface: 'unknown',
            isDeleted: false,
          };
        }
        return device;
      })
    );

    // Change this to ControllerTypeFilter.All if you also need to get CCAPs
    this.store.dispatch(getDevicesAction({ data: { type: ControllerTypeFilter.Xpac, search: id } }));

    return obs;
  }
}
